import { entityAccess } from './permissions';
import { emptyStringToNull } from '@root/src/utils/commons/objects';
import { parseUTCDate } from '@root/src/utils/formatters/dates';
import { UserBack, UserFront } from './types';

export const userFromBack = (
  { resetPasswordExpires, _id, member, accessLevel, ...rest } = {} as UserBack,
): UserFront => {
  let formattedMember;

  if (typeof member === 'string' && member !== _id) {
    formattedMember = { id: member };
  } else if (member && typeof member === 'object') {
    formattedMember = {
      id: member._id,
      name: member.name,
      state: member.state,
    };
  }

  return {
    ...rest,
    resetPasswordExpires: resetPasswordExpires ? parseUTCDate(resetPasswordExpires) : undefined,
    id: _id,
    ...entityAccess(accessLevel),
    member: formattedMember,
  } as UserFront;
};

export const userToBack = ({ resetPasswordExpires, id, member, ...rest } = {} as UserFront): Partial<UserBack> => {
  const payload: Partial<UserBack> = {
    ...rest,
    resetPasswordExpires: resetPasswordExpires?.toISOString(),
    member: member?.id,
    _id: id || '',
  };

  // Convert all empty strings and undefined values to null for standardization
  return emptyStringToNull(payload);
};
